<template>
  <div class="space-y-4">
    <div class="font-bold text-xl text-gray-900">
      {{ $t('comments.list_title') }}
      <span v-if="total" class="text-primary">{{ total }}</span>
    </div>
    <CommentsCommentForm
      :entity-id="id"
      :entity-type="entityType"
      :disabled="!authStore.auth"
      @click="onClick"
      @create="emits('create')"
      @edit="emits('edit')"
    />
    <template
      v-for="(comment, idx) in commentsList?.state.hits"
      :key="comment.id"
    >
      <CommentsComment
        :comment="comment"
        :is-last="idx === (commentsList?.state.hits.length || 0) - 1"
        :entity-type="entityType"
        @create="emits('create')"
        @edit="emits('edit')"
      />
    </template>
    <BaseButton
      v-if="
        commentsList &&
        !commentsList?.allRecordsLoaded &&
        !commentsList?.state.processing
      "
      look="link"
      size="none"
      class="w-full font-bold text-sm"
      @click="onShowMore"
      >{{ $t('comments.show_more') }}
    </BaseButton>
    <div
      v-if="!commentsList || commentsList?.state.processing"
      class="py-3 flex justify-center"
    >
      <BaseSpinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { useAuth } from '~/stores/auth'
import { useComments } from '~/stores/comments'
import { EntityType } from '~/models/common'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    default: 0,
  },
  entityType: {
    type: String as PropType<EntityType>,
    required: true,
  },
})

const emits = defineEmits(['loaded', 'create', 'edit'])

const authStore = useAuth()
const commentsStore = useComments()
const commentsList = computed(() => commentsStore.comments[0])

async function onShowMore() {
  await commentsList.value?.nextPage()
}

function onClick() {
  if (!authStore.auth) {
    authStore.openLoginModal()
  }
}

onMounted(async () => {
  commentsStore.initCommentsList(props.id, props.entityType)
  await commentsList.value?.getPage()
  emits('loaded')
})
</script>
